define('views/modules/calendar/animated-session/animation/lists/animation-list',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/user',
    // events
    'services/events/animated-session-events',
    // models & collections
    'collections/calendar/session/animations',
    'models/calendar/session/tag',
    // views
    'views/parts/list/fetch-list',
    'views/modules/calendar/animated-session/animation/lists/animation-list-item',
    'views/modules/calendar/animated-session/animation/animation-detail-modal',
    'views/modules/calendar/animated-session/animation/animation-rename-modal',
    'views/modules/calendar/animated-session/animation/animation-edit-modal',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    User,
    // events
    AnimationEvents,
    // models & collections
    CAnimations,
    MTag,
    // views
    VFetchList,
    VExerciseAnimationItem,
    VAnimationDetailModal,
    VAnimationRenameModal,
    VAnimationEditModal
) {

    var VExerciseAnimationList = VFetchList.extend({
        item: VExerciseAnimationItem,
        className: "animation-list",
        sortable: {
            group: {
                name: "animation",
                pull: "no-clone",
                put: false
            },
            sort: false,
            delay: Viewport.width() <= 768 ? 50 : 0,
            handle: ".box-img",
            onEnd: "onDragEnd",
            onMove: "onDragMove",
        },

        getItemOptions: function(options) {
            return _.extend(options, _.pick(this.options, ['custom', 'manager']));
        },

        initialize: function(opt) {
            opt = _.extend({}, { fetch: true }, opt);
            VExerciseAnimationList.__super__.initialize.call(this, opt);

            this.resetFilter = true;

            _.extend(this, {
                group: opt.group,
                tags: opt.tags,
                selectedCollection: new CAnimations(null, {
                    // makes it possible to use custom model on the
                    model: this.collection.model
                }),
            });
            // listeners
            this.listenTo(this.collection, {
                'animation:click': this.onAnimationClick,
                'animation:detail': this.onAnimationDetail,
                'animation:rename': this.onAnimationRename,
                'animation:edit': this.onAnimationEdit,
                'animation:reverted': this.onAnimationReverted,
            });

            if (this.tags) {
                this.listenTo(this.tags, 'sync', this.onTagsSync);
            }
        },

        render: function() {
            var collection = this.collection,
                options = this.options,
                tags = this.tags;

            if (this.resetFilter) {
                collection.resetFilter().reset(null, { silent: true });
            }

            VExerciseAnimationList.__super__.render.apply(this, arguments);

            if (this.options.fetch && !tags) {
                this.fetch();
            }

            if (tags && this.resetFilter) {
                tags.fetch();
            }

            return this;
        },

        fetch: function() {
            var collection = this.collection;
            if (this.options.aysnc) {
                collection.getFirstPage();
            } else {
                collection.fetch();
            }
        },

        setQuery: function(value) {
            this.collection.setSearchTextFilter(value);
            this.collection.fetch({reset:true});
        },

        reset: function() {
            this.selectedCollection.reset();
            this.$('.animation-box').removeClass('active');
            this.trigger('selected:change', false, this.selectedCollection);
        },

        getSelectedAnimations: function() {
            return this.selectedCollection.models;
        },
        /////////////////
        // Drag & drop //
        /////////////////
        // dragging ended
        onDragEnd: function(e) {
            AnimationEvents.dragAnimationEnd(e);
        },

        // Event when you move an item in the list or between lists.
        onDragMove: function(e) {
            this.$(e.dragged).trigger("animation:drag", e);
            // cancel the move from sortable, we're handling that ourselves.
            return false;
        },
        ////////////
        // events //
        ////////////
        onAnimationClick: function(model, val) {
            if (val) {
                this.selectedCollection.add(model);
            } else {
                this.selectedCollection.remove(model, { silent: true });
            }
            this.trigger('selected:change', this.selectedCollection, val);
        },

        onAnimationDetail: function(model) {
            var view = this.view || {};
            if (!view.modal) {
                view.modal = new VAnimationDetailModal();
            }
            view.modal.setModel(model).render();
        },

        onAnimationRename: function(model) {
            var view = this.view || {};
            if (!view.renameModal) {
                view.renameModal = new VAnimationRenameModal({
                    group: User.getMainGroup()
                });

                this.listenTo(view.renameModal, 'form:success', this.onRenameSuccess);
            }
            view.renameModal.setAnimation(model).render();
        },

        onAnimationEdit: function(model) {
            this.view.editModal = new VAnimationEditModal({
                group: this.group,
                model: model
            });

            this.listenTo(this.view.editModal, 'form:success', this.onRenameSuccess);
            this.view.editModal.render();
        },

        onRenameSuccess: function() {
            this.resetFilter = false;
            this.collection.fetch({ force: true });
            this.render();
        },

        onAnimationReverted: function(model) {
            this.resetFilter = false;
            var self = this;
            this.collection.fetch({ force: true }).done(function() {
                AnimationEvents.exerciseReverted(self.collection.where({ _id: model.get('_id') }));
                self.render();
            });

        },

        onTagsSync: function(tagsCollection) {
          if (this.collection.tags && this.collection.tags.length > 0 && this.collection.tags["0"] === "000000000000000000000000" && _.isEmpty(this.collection.searchText))
              return;

          this.fetch();
        },

    });

    return VExerciseAnimationList;

});

